export default __webpack_public_path__ + "static/media/kitchen5-afterB-1920w.3918ab3c.avif";